module.exports = __webpack_public_path__ + "static/media/tallyLogo.b2286f12.svg";